// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'

const formatDataForSort = col => {
  switch (col) {
    case 'attachments' :
      // take the comment's date, if it has attachments don't modify the date
      // if it does, multiply it by two. then simply use those calculated date
      // values to sort upon. this allows for comments with or without attachments
      // then to be separate groups then within those groups, sorted by date.
      return (a, b) => ([
        a.createTimestamp * (a[col].length ? 1 : 2),
        b.createTimestamp * (b[col].length ? 1 : 2),
      ])

    // sort this value as a number since the default case converts the value to a string.
    case 'createTimestamp' :
      return (a, b) => ([
        a[col],
        b[col],
      ])

    default :
      return (a, b) => ([
        castToString(a[col]).toLowerCase(),
        castToString(b[col]).toLowerCase(),
      ])
  }
}

export default formatDataForSort
